import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';
import { callQueueReducer } from './callQueueSlice';

const persistConfig = {
  key: 'callQueue',
  storage,
  whitelist: ['callQueue'],
};

export const persistedCallQueueReducer = persistReducer(
  persistConfig,
  callQueueReducer
);
